import type { ComponentProps } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const SAFE_LINK = /^(https?:|mailto:)/i;

/** Only absolute http(s)/mailto links are clickable; anything else (javascript:, data:, relative) is plain text. */
export function isSafeHref(href: string | undefined): href is string {
  return href !== undefined && SAFE_LINK.test(href.trim());
}

function Link({ href, children }: ComponentProps<"a">) {
  if (!isSafeHref(href)) return <span>{children}</span>;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer nofollow">
      {children}
    </a>
  );
}

/**
 * Model output is untrusted. react-markdown builds React elements (no innerHTML) and, without rehype-raw,
 * ignores raw HTML in the source. Images are dropped (no remote fetches / tracking pixels) and links are
 * restricted to http(s)/mailto.
 */
export function Markdown({ text }: { text: string }) {
  return (
    <div className="markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        disallowedElements={["img"]}
        urlTransform={(url) => (isSafeHref(url) ? url : "")}
        components={{ a: Link }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
